export const url = {
  createProduct: "api/Product/Create",
  getAllAttributes: "api/ProductAttributes/GetAll",
  getAvailableTypes: "api/Product/AvailableTypes",
  getProduct: "api/Product/product",
  updateProduct: "api/Product/Update",
  getAllCategories: "api/Category/Categories",
  uploadMedia: "api/Media/UploadMedia",
  createAttribtue: "api/ProductAttributes/Create",
  getAllProgramAndLevels: "api/ProgramAndLevels/ProgramAndLevels",
  createBenefit: "api/ItemBenefits/Create",
  getAllBenefits: "api/ItemBenefits/Benefits",
  createMembershp: "api/Membership/Create",
  udpateMembership: "api/Membership/Update",
  getMembership: "api/Membership/Membership",
  deleteProduct: "api/Product/Delete",
  getProductReferenceInPurchase: "api/Product/GetReferenceInPurchases",
  deleteMembership: "api/Membership/Delete",
  getMembershipReferenceInPurchase: "api/Membership/GetReferenceInPurchases",
  getDonationReferenceInPurchase: "api/Donation/GetReferenceInPurchases",

  createService: "api/Service/Create",
  updateService: "api/Service/Update",
  getService: "api/Service/Service",
  getServices: "api/Service/Services",
  getAllBeneficiaries: "api/Beneficiary/Beneficiaries",
  deleteService: "api/Service/delete",
  getServiceReferenceInPurchase: "api/Service/GetReferenceInPurchases",

  createDonation: "api/Donation/Create",
  updateDonation: "api/Donation/Update",
  getDonations: "api/Donation/Donations",
  exportDonations: "api/Donation/ExportDonations",
  getDonation: "api/Donation/Donation",
  getAllItems: "api/Product/GetItems",
  createBeneficiary: "api/Beneficiary/Create",
  createCategory: "api/Category/Create",
  updateVariant: "api/Product/UpdateVariant",

  payments: "api/PaymentTransactions/Payments",
  exportPayments: "api/PaymentTransactions/Export",
  getPayment: "api/PaymentTransactions/Payment",

  subscriptions: "api/Subscription/Subscriptions",
  getSubscription: "api/Subscription/Subscription",
  createSubscription: "api/Subscription/NewSubscription",
  updateSubscription: "api/Subscription/Update",
  cancelSubscription: "api/Subscription/Cancel",
  pauseSubscription: "api/Subscription/Pause",
  resumeSubscription: "api/Subscription/Resume",

  invoices: "api/BillingInvoice/Invoices",
  getInvoice: "api/BillingInvoice/Invoice",
  getDonars: "api/Donation/Donors",
  exportDonors: "api/Donation/ExportDonors",
  deleteDonation: "api/Donation/Delete",
  getContact: "api/Contact/Contact",
  getContacts: "api/Contact/Contacts",
  createContact: "api/Contact/Create",
  updateContact: "api/Contact/Update",
  deleteContact: "api/Contact/Delete",
  findContact: "api/Contact/FindContact",
  getMindMeContacts: "api/Contact/GetMindMeContacts",
  checkContactEmailExistence: "api/Contact/CheckEmailExistence",

  getRecentPaymentsData: "api/Dashboard/RecentPayments",
  getRecnetCustomersData: "api/Dashboard/RecentCustomers",
  getActiveSubscriptionsWidgetData: "api/Dashboard/ActiveSubscriptions",
  getPaymentBreakDownData: "api/Dashboard/PaymentBreakDown",
  getActivityData: "api/Dashboard/Activity",
  updateInventorySettings: "api/Product/UpdateInventorySettings",
  getNewOrders: "api/Dashboard/NewOrders",
  getActivityGraphData: "api/Dashboard/ActivityGraphData",
  itemBreakDownGraphData: "api/Dashboard/ItemBreakDowns",
  getCountriesWithState: "api/Country/Countries",
  getFundingData: "api/Dashboard/Fundings",

  createBusiness: "api/MerchantAccounts/CreateBusiness",
  getBusinesses: "api/MerchantAccounts/Businesses",
  createMerchantAccount: "api/MerchantAccounts/CreateMerchantAccount",
  getMerchantAccounts: "api/MerchantAccounts/MerchantAccounts",
  updateMerchantApplicationStatus:
    "api/MerchantAccounts/UpdateMerchantApplicationStatus",
  updateMerchantPaymentSettings:
    "api/MerchantAccounts/UpdateMerchantPaymentSettings",
  deleteMerchantAccount: "api/MerchantAccounts/DeleteMerchantAccount",
  cancelMerchantAccount: "api/MerchantAccounts/CancelMerchantAccount",
  getMedias: "api/Media/Medias",
  IsNMIUserNameAvailable: "api/MerchantAccounts/IsNMIUserNameAvailable",
  setDefaultMerchantAccount: "api/MerchantAccounts/SetDefault",

  productStatusUpdate: "api/Product/UpdateStatus",
  membershipStatusUpdate: "api/Membership/UpdateStatus",
  serviceStatusUpdate: "api/Service/UpdateStatus",
  donationStatusUpdate: "api/Donation/UpdateStatus",
  getCompleteApplicationLink: "api/MerchantAccounts/ApplicationLink",
  getIsValidBusiness: "api/MerchantAccounts/IsFiserveBusinessNameExists",
  getOrdersGridData: "api/Order/Orders",

  getCheckoutGridData: "api/CheckOuts/CheckOuts",
  getCheckOut: "api/CheckOuts/CheckOut",
  saveCheckOut: "api/CheckOuts/Create",
  updateCheckOut: "api/CheckOuts/Update",
  getCustomerFacingCheckOut: "api/CheckOuts/GetCustomerFacingCheckOut",
  getCheckoutRelatedGridData: "api/CheckOuts/RelatedCheckOuts",

  createPurchaseLink: "api/PurchaseLink/Create",
  getPurchaseLink: "api/PurchaseLink/PurchaseLink",
  updatePurchaseLink: "api/PurchaseLink/Update",
  getPurchaseLinkGridData: "api/PurchaseLink/PurchaseLinks",
  createPaymentIntent: "api/CheckOuts/CreatePaymentIntent",
  purchaseCheckOutItems: "api/CheckOuts/PurchaseCheckOutItems",
  purchaseLinkCheckoutItems: "api/PurchaseLink/PurchaseItems",
  deletePurchaseLink: "api/PurchaseLink/Delete",

  deletePaymentMethod: "api/PaymentMethod/DeletePaymentMethod",
  getPaymentMethodReferenceInPurchases:
    "api/PaymentMethod/GetPaymentMethodWithReferences",
  getPaymentMethods: "api/PaymentMethod/GetPaymentMethods",
  getPaymentMethod: "api/PaymentMethod/GetPaymentMethod",
  createPaymentMethod: "api/PaymentMethod/Create",
  updatePriority: "api/PaymentMethod/UpdatePriority",
  getPaymentMethodSummary: "api/PaymentMethod/GetPaymentMethodSummary",

  createNewInvoice: "api/BillingInvoice/NewInvoice",
  updateInvoice: "api/BillingInvoice/Update",
  deleteInvoice: "api/BillingInvoice/Delete",
  payInvoice: "api/BillingInvoice/Pay",
  cancelInvoice: "api/BillingInvoice/Cancel",
  newPayment: "api/PaymentTransactions/Payment",
  updatePayment: "api/PaymentTransactions/Update",
  cancelPayment: "api/PaymentTransactions/Cancel",
  refundPayment: "api/PaymentTransactions/Refund",

  createSeller: "api/Seller/Create",
  updateSeller: "api/Seller/Update",
  deleteSeller: "api/Seller/Delete",
  getSeller: "api/Seller/Get",
  getSellerNames: "api/Seller/GetSellerNames",
  checkOutStatusUpdate: "api/CheckOuts/UpdateStatus",
  deleteCheckout: "api/CheckOuts/Delete",
  getSellers: "api/Seller/Sellers",

  getPromotionGridData: "api/PromoCodes/PromoCodes",
  getPromotion: "api/PromoCodes/PromoCode",
  createPromotion: "api/PromoCodes/Create",
  updatePromotion: "api/PromoCodes/Update",
  deletePromotion: "api/PromoCodes/Delete",
  checkCodeUniqueness: "api/PromoCodes/CheckCodeUniqueness",

  getTimeZones: "api/TimeZones/TimeZones",
  getGeneralSettings: "api/Account/GetSettings",
  getReceiptDetails: "api/Account/GetReceiptDetails",
  // Anonymous: the public receipt page is opened from a link in the receipt email.
  getReceiptByToken: "api/Receipt/GetByToken",
  updateGeneralSettings: "api/Account/UpdateSettings",
  updateAccountSettings: "api/Account/UpdateAccountSettings",
  findAccount: "api/Account/FindAccount",
  getApplicationSettings: "api/Account/GetApplicationSettings",

  getCategories: `api/Category/Categories`,
  renameCategory: `api/Category/Rename`,
  deleteCategory: `api/Category/Delete`,

  voidPayment: "api/PaymentTransactions/Void",

  getPayouts: "api/Funding/Payouts",
  getFundings: "api/Funding/Fundings",
  getPayoutDetails: "api/Funding/GetPayoutDetails",

  createListInterestTag: "api/ListInterestTag/Create",
  getMindMeListInterestTag: "api/ListInterestTag/GetMindMeListInterestTag",
  getFiservMCCS: "api/MerchantAccounts/GetFiservMCCS",
  checkPromoCodeByCode: "api/PromoCodes/PromoCodeByCode",

  getMerchantAccountsSummary: "api/MerchantAccounts/GetMerchantAccountsSummary",

  getFundRaisersSummary: "api/FundRaiser/GetFundRaisersSummary",

  // Single agency list (id/name/branding/status) shared by both the merchant and fund raiser
  // admin grids' agency filter dropdowns.
  getAgencies: "api/Account/GetAgencies",
};
